<template>
  <div class="p-contacts__no-contacts">
    <span class="p-contacts__no-contacts__text">{{ $t('contacts.messageNoContacts') }}</span>
    <img class="p-contacts__no-contacts__image" src="../../assets/contacts_not_found.svg" :alt="$t('contacts.altImageMessage')">
    <div class="p-contacts__no-contacts__horizontal-align">
      <span class="p-contacts__no-contacts__text p-contacts__no-contacts__text__bottom">{{ $t('dashboard.messageAddOneNow') }}</span>
      <VButton
          type="cta-1"
          size="input"
          class="p-contacts__no-contacts__create-button"
          :action="addContact"
          data-test="contacts-add-button"
          data-ec="contacts"
          data-et="new_contact_top">
        <PlusIcon />
        <span>{{ $t('contacts.addContact') }}</span>
      </VButton>
    </div>
  </div>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import { PlusIcon } from '@/components/icons/fontIcons';

export default {
  name: 'VNoContactsMessage',
  components: {
    VButton,
    PlusIcon,
  },
  props: {
    addContact: Function,
  },
};

</script>

<style scoped>
.p-contacts__no-contacts {
  text-align: center;
  margin-top: var(--spacing-base);
}

.p-contacts__no-contacts__image {
  width: 40%;
  margin-bottom: var(--spacing-base);
  margin-left: 25%;
}

.p-contacts__no-contacts__text {
  font-family: "Roboto Slab", serif !important;
  font-weight: 500 !important;
  margin-right: var(--spacing-base);
  font-size: 24px;
}

.p-contacts__no-contacts__text__bottom {
  line-height: 38px;
  display: inline-block;
  width: 100%;
}

.p-contacts__no-contacts__create-button {
  display: inline-block;
  float: none !important;
  margin-top: var(--spacing-base);
}

.p-contacts__no-contacts__horizontal-align {
  display: block;
}
</style>
